module.exports = __webpack_public_path__ + "img/logo.5c426a69.png";